import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-success-story',
  templateUrl: './success-story.component.html',
  styleUrls: ['./success-story.component.scss']
})
export class SuccessStoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
